<template>
  <div ref="modal" class="modal modal-filter-details fade" id="database-management-modal" role="dialog" aria-labelledby="location-label" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            {{ element.id ? `Edit - ID: ${element.id}` : 'Create' }}
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeButton">
              <span aria-hidden="true">&times;</span>
            </button>
          </h4>
        </div>
        <div class="modal-body">
          <slot name="body"/>
        </div>
        <div class="modal-footer">
          <slot name="footer"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: {
      required: true
    }
  },

  beforeDestroy () {
    this.closeModal()
  },

  methods: {
    closeModal () {
      if (this.$refs.modal.classList.contains('in')) {
        this.$refs.closeButton.click()
      }
    }
  }
}
</script>
